import fetch from '@/utils/fetch';

const model = {
  state: {
    order: {},
    orderLoading: false,
    logistics: [],
    logisticsLoading: false,
    productTypes: [],
    cancelLoading: false, // 取消订单弹框确认按钮loading状态
    expressList: {},
    sfType: 1,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { OptOrderDetail }, getState }) => ({
    async getDetail(params) {
      OptOrderDetail.setState({ orderLoading: true });
      const order = await fetch('/saasmerchant/web/order/querydetail', {
        params,
      });
      OptOrderDetail.setState({ orderLoading: false });
      if (order) {
        OptOrderDetail.setState({ order, logisticsLoading: true });
        /**
         * 同城发货且不是顺丰同城则不获取物流信息
         * 顺丰同城包括 'SFTC' 'SFJS' 'CLS_SFTC'
         */
        // if (
        //   order.dispatch_method === 1 &&
        //   order.express_company_shortcut.toUpperCase() !== 'SFTC' &&
        //   order.express_company_shortcut.toUpperCase() !== 'SFJS' &&
        //   order.express_company_shortcut.toUpperCase() !== 'CLS_SFTC'
        // ) {
        //   OptOrderDetail.setState({ logisticsLoading: false, logistics: { traces: [] } });
        //   return;
        // }
        // 物流信息
        const logistics = await fetch('/saasmerchant/web/order/deliveryinfo', {
          params: { orderId: params.orderId },
        });
        OptOrderDetail.setState({ logisticsLoading: false });
        logistics &&
          OptOrderDetail.setState({
            logistics,
          });
      }
    },
    async cancelOrder(params) {
      OptOrderDetail.setState({ cancelLoading: true });
      const { sub_shop_id, shopType } = getState().basic;
      const result = await fetch('/saasmerchant/web/order/ordercancel', {
        type: 'POST',
        useJson: true,
        params: { subStatus: shopType === 'main' ? 1 : 0, subShopId: sub_shop_id, ...params },
      });
      OptOrderDetail.setState({ cancelLoading: false });
      return result;
    },
    async bindExpress(params) {
      const { sub_shop_id, shopType } = getState().basic;
      const data = await fetch('/trade/order/bindexpressno', {
        type: 'POST',
        params: { sub_status: shopType === 'main' ? 1 : 0, sub_shop_id, ...params },
      });
      return data;
    },
    async detailGetProductType() {
      const { shop_id, sub_shop_id } = getState().basic;
      const result = await fetch('/saasmerchant/web/express/getproducttype', {
        type: 'POST',
        params: {
          shopId: shop_id,
          subShopId: sub_shop_id,
        },
        useJson: true,
      });
      result && OptOrderDetail.setState({ productTypes: result });
    },
    async onDelivery(params) {
      const { shop_id, sub_shop_id, shopType } = getState().basic;
      const data = await fetch('/saasmerchant/web/order/senddelivery', {
        params: {
          ...params,
          deliveryInfo: params.deliveryInfo ? JSON.parse(params.deliveryInfo) : [],
          shopId: shop_id,
          subShopId: sub_shop_id,
          subStatus: shopType === 'main' ? 1 : 0,
        },
        type: 'POST',
        useJson: true,
      });
      return data;
    },
    // 获取快递列表
    async getExpressList(params = {}) {
      const expressList = await fetch('/saasmerchant/web/express/getofflineexpress', {
        params,
      });
      expressList && OptOrderDetail.setState({ expressList });
    },
  }),
};

export default model;
